// extracted by css-extract-rspack-plugin
export default {"root":"Uv1s3V","selected-count":"rBQk26","selectedCount":"rBQk26"};